import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';
import Layout from './Layout';

function ProtectedLayout() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Immediate redirect if not authenticated
  if (!isAuthenticated) {
    // Redirect to the login page, but save the current location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If authenticated, render the layout with nested routes via Outlet
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

export default ProtectedLayout;